import script from "./WechatSub.vue?vue&type=script&setup=true&lang=js"
export * from "./WechatSub.vue?vue&type=script&setup=true&lang=js"

import "./WechatSub.vue?vue&type=style&index=0&id=2936ac02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2936ac02"]])

export default __exports__